import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import Checkbox from 'ext-ui/components/Checkbox/Checkbox'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import { OrgExpenseReportStatus } from 'src/models/orgExpenseReports.models'
import { css } from 'styled-components'

interface TransactionReviewStatusFilterProps {
  reviewStatusSet: Set<string>
  handleReviewStatusesSelection: (status: string) => Set<string>
}

const TransactionReviewStatusFilter: React.FC<
  TransactionReviewStatusFilterProps
> = ({ reviewStatusSet, handleReviewStatusesSelection }) => {
  const translate = useTranslate()
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        {translate('Review Status')}
      </div>
      <div className="flex-row align-center gap-2">
        <Checkbox
          id="review-status-flagged"
          onChange={(): void => {
            handleReviewStatusesSelection(OrgExpenseReportStatus.Flagged)
          }}
          checked={reviewStatusSet.has(OrgExpenseReportStatus.Flagged)}
          aria-label={translate('Flagged')}
        />
        <label
          htmlFor="review-status-flagged"
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            cursor: pointer;
          `}
        >
          {translate('Flagged')}
        </label>
      </div>
      <div className="flex-row align-center gap-2">
        <Checkbox
          id="review-status-pending"
          onChange={(): void => {
            handleReviewStatusesSelection(OrgExpenseReportStatus.PendingReview)
          }}
          checked={reviewStatusSet.has(OrgExpenseReportStatus.PendingReview)}
          aria-label={translate('Pending Review')}
        />
        <label
          htmlFor="review-status-pending"
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            cursor: pointer;
          `}
        >
          {translate('Pending Review')}
        </label>
      </div>
      <div className="flex-row align-center gap-2">
        <Checkbox
          id="review-status-reviewed"
          onChange={(): void => {
            handleReviewStatusesSelection(OrgExpenseReportStatus.Reviewed)
          }}
          checked={reviewStatusSet.has(OrgExpenseReportStatus.Reviewed)}
          aria-label={translate('Reviewed')}
        />
        <label
          htmlFor="review-status-reviewed"
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            cursor: pointer;
          `}
        >
          {translate('Reviewed')}
        </label>
      </div>
    </div>
  )
}

export default TransactionReviewStatusFilter
